export const trace = !import.meta.env.PROD ? (...args) => console.log('[src/index]', ...args) : () => {};
